import React, { useEffect, useState } from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";


function SummaryCardsForExpiring({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);

    const currentMonthName = new Date().toLocaleString("default", {
        month: "short",
    });

    const summary = [
        {
            amount: summaryData?.total || 0,
            label: `Total Bookings`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: '',
        },
        {
            amount: summaryData?.CurMonthExpiring || 0,
            label: `Current Month`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'BCM',
        },
        {
            amount: summaryData?.CurMonthExpiring || 0,
            label: `Upcoming Month`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'BNM',//Expiring Next Month
        },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => (
                    <Card selectedId={selectedId} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <div className="h-16">
                            <Value color={item.color}>{item.amount}</Value>
                            <Label>
                                {item.label}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between  break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  
  ${({ color }) =>
        color}
`;

export default SummaryCardsForExpiring;

